import { OrganizationCountry } from "../enums/country";
const SALES_TAX_COUNTRIES = [OrganizationCountry.Canada, OrganizationCountry.UnitedStates];
export const isSalesTaxCountry = (country) => {
    if (!country) {
        return false;
    }
    return SALES_TAX_COUNTRIES.includes(country);
};
export const isTaxRegistrationNumberRequired = (country) => country === OrganizationCountry.Canada;
export const isTaxRegistrationNumberPrefilled = (country) => country === OrganizationCountry.UnitedStates;
